export enum ControlTypeEnum {
  TextBox = 0,
  CheckBox = 1,
  RadioButtons = 2,
  ComboBox = 3,
  GridOnly = 4,
  Label = 5,
  CustomTextBox = 6,
  CustomComboBox = 7,
  Notes = 8,
  DateWCalendar = 9,
  Month = 10,
  Email = 11,
  Web = 12,
  CustomWeb = 13,
  CustomCheckBox = 14,
  CustomDate = 15,
  CustomMonth = 16,
  CustomNotes = 17,
  CustomListBox = 18,
  RichTextBox = 19,
  NoControl = 99,
}

export type ControlType = `${ControlTypeEnum}` extends `${infer U extends number}` ? U : never;
